const Menu3Dots = ({ backgroundColor, dotsColor }: { backgroundColor?: string, dotsColor?: string }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="48"
        cy="48"
        r="48"
        fill={backgroundColor ? backgroundColor : "white"}
      />
      <circle cx="20" cy="48" r="9" fill={dotsColor ? dotsColor : "black"} />
      <circle cx="48" cy="48" r="9" fill={dotsColor ? dotsColor : "black"} />
      <circle cx="76" cy="48" r="9" fill={dotsColor ? dotsColor : "black"} />
    </svg>
  );
};

export default Menu3Dots;
